import TodayIcon from "@icons/myicons/clock-time-arrow.svg?react";
import PurchaseIcon from "@icons/myicons/cash.svg?react";
import TotalIcon from "@icons/myicons/chart.svg?react";
import DividendsIcon from "@icons/myicons/coins-growth.svg?react";
import { InvestmentMetricKey } from "./investmentListFields";

// Stand in for the chip labels when those are switched off; the chip order in
// the settings shows them next to the names, as their legend.
export const METRIC_ICONS: Record<InvestmentMetricKey, typeof TodayIcon> = {
  today: TodayIcon,
  purchase: PurchaseIcon,
  total: TotalIcon,
  dividends: DividendsIcon,
};
